.optionsWrapper {
  padding: 0px 20px 0 20px;

  .options {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 16px;
  }

  .option {
    display: flex;
    position: relative;
    align-items: center;
    height: 80px;
    border-radius: 24px;
    background: rgba(243, 237, 223, 0.5);
    box-sizing: border-box;
    padding-left: 56px;
    padding-right: 8px;
    cursor: pointer;

    &__selected::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 24px;
      border: 3px solid #c85bff;
    }
  }

  .radio {
    border-radius: 39px;
    border: 2px solid #ded9ce;
    border: 2px solid color(display-p3 0.868 0.85 0.8103);
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translate(0, -50%);
  }

  .priceWrapeprTitle {
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  .price {
    color: #231e19;
    font-size: 12px;
    font-weight: 510;
    line-height: 16px;
    letter-spacing: 0.036px;
  }

  .option__selected {
    .radio {
      background: url(../img/radio.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      border: none;
    }
  }
}

.optionStyleV2 {
  .option {
    padding-right: 16px;
  }

  .priceWrapeprTitle {
    text-transform: none;
    font-weight: 600;
  }
}

// Dark mode
:global body.dark {
  :local {
    .priceWrapeprTitle,
    .price {
      color: #fffbf2;
    }

    .option {
      background-color: #2a2928;
    }

    .radio {
      border-color: #7b766f;
    }
  }
}
